<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       :width="width"
       :height="height"
       viewBox="0 0 7 7"
       role="presentation"
       @click="$emit('click')">
    <g :fill="disabled ? disabledStateColor : iconColor">
      <path d="M3.5 2.8L6.3 0l.7.7-2.8 2.8L7 6.3l-.7.7-2.8-2.8L.7 7 0 6.3l2.8-2.8L0 .7.7 0l2.8 2.8z"/>
    </g>
  </svg>
</template>

<script>
  import iconMixin from './iconMixin.js'

  export default {
    mixins: [iconMixin]
  }
</script>
